import { CustomerOrdersApiError, toCustomerOrdersErrorMessage } from './errors'
import { API_BASE, requestApiBlob, requestApiJson } from '../../shared/api/client'
import { withCookieFirstRequest } from '../../shared/api/cookieAuthRequest'

export { API_BASE }

export const requestCustomerOrdersJson = async <T>(path: string, token?: string | null): Promise<T> => {
  return requestApiJson<T>({
    path,
    init: withCookieFirstRequest({
      init: {
        method: 'GET',
      },
      bearerFallbackToken: token,
    }),
    toErrorMessage: toCustomerOrdersErrorMessage,
    createError: (status, message) => new CustomerOrdersApiError(status, message),
  })
}

export const requestCustomerInvoiceBlob = async ({
  token,
  downloadUrl,
}: {
  token?: string | null
  downloadUrl: string
}) => {
  return requestApiBlob({
    url: downloadUrl,
    init: withCookieFirstRequest({
      init: {
        method: 'GET',
      },
      bearerFallbackToken: token,
    }),
    toErrorMessage: toCustomerOrdersErrorMessage,
    createError: (status, message) => new CustomerOrdersApiError(status, message),
  })
}
